import React, { useEffect, useState } from "react";
import axios from "axios";
import { Helmet } from "react-helmet";
import config from "../config";
import { check_login } from "../auth/auth";
import toast from "react-hot-toast";
import Navigation from "../components/navigation";

type CommiTransaction = {
    id: string;
    points: number;
    reason: string;
    awarded_by_email: string;
    created_at: string;
};

type CommiResponse = {
    total: number;
    transactions: CommiTransaction[];
};

function Commipunten() {
    const [claims] = useState(check_login(true));
    const [data, setData] = useState<CommiResponse>({
        total: 0,
        transactions: []
    });

    useEffect(() => {
        if (!claims) return;

        axios
            .get(config.api_url + "/commi/me/")
            .then((response) => {
                setData(response.data);
            })
            .catch(() => {
                toast.error("Commipunten konden niet geladen worden.");
            });
    }, [claims]);

    return (
        <>
            {claims && (
                <div className="dark:bg-zinc-900 min-h-screen">
                    <Navigation/>
                    <Helmet>
                        <title>Mijn commipunten - Hermes Gent</title>
                    </Helmet>

                    <div className="lg:w-8/12 w-11/12 pt-20 pb-40 mx-auto">
                        <h1 className="font-extrabold text-2xl md:text-3xl xl:text-4xl text-gray-700 dark:text-gray-300 mb-10">
                            MIJN COMMIPUNTEN
                        </h1>

                        <div className="shadow-md border border-zinc-200 dark:border-zinc-800 dark:bg-black/40 rounded-lg p-8 mb-10">
                            <p className="text-zinc-500 dark:text-zinc-400 mb-2">
                                Totaal
                            </p>

                            <p className="font-extrabold text-5xl text-gray-700 dark:text-gray-300">
                                {data.total}
                            </p>
                        </div>

                        <h2 className="font-bold text-xl text-gray-700 dark:text-gray-300 mb-5">
                            Historiek
                        </h2>

                        {data.transactions.length === 0 ? (
                            <p className="text-zinc-500">
                                Je hebt nog geen commipunten.
                            </p>
                        ) : (
                            <div className="overflow-x-auto">
                                <table className="w-full border-collapse">
                                    <thead>
                                        <tr className="border-b border-zinc-300 dark:border-zinc-700">
                                            <th className="text-left p-4 text-gray-700 dark:text-gray-300">
                                                Punten
                                            </th>
                                            <th className="text-left p-4 text-gray-700 dark:text-gray-300">
                                                Reden
                                            </th>
                                            <th className="text-left p-4 text-gray-700 dark:text-gray-300">
                                                Door
                                            </th>
                                            <th className="text-left p-4 text-gray-700 dark:text-gray-300">
                                                Datum
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {data.transactions.map((transaction) => (
                                            <tr
                                                key={transaction.id}
                                                className="border-b border-zinc-200 dark:border-zinc-800"
                                            >
                                                <td
                                                    className={`p-4 font-bold ${
                                                        transaction.points > 0
                                                            ? "text-green-600"
                                                            : "text-red-600"
                                                    }`}
                                                >
                                                    {transaction.points > 0 ? "+" : ""}
                                                    {transaction.points}
                                                </td>

                                                <td className="p-4 text-zinc-800 dark:text-zinc-200">
                                                    {transaction.reason}
                                                </td>

                                                <td className="p-4 text-zinc-800 dark:text-zinc-200">
                                                    {transaction.awarded_by_email}
                                                </td>

                                                <td className="p-4 text-zinc-800 dark:text-zinc-200">
                                                    {new Date(transaction.created_at).toLocaleString("nl-BE")}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
}

export default Commipunten;